import React, { useState, useEffect, useMemo } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Message from "../../../Components/Message";

const DamagesTransactionsModal = ({
  show,
  handleClose,
  mode,
  paymentData,
  products,
  handleSubmit,
  apiError
}) => {
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [formData, setFormData] = useState({
    product: "",
    amount: "",
    notes: ""
  });

  useEffect(() => {
    if (paymentData) {
      setFormData(paymentData);
    } else {
      setFormData({
        product: "",
        amount: "",
        notes: ""
      });
    }
  }, [paymentData, show]);

  useEffect(() => {
    if (apiError) {
      setError(apiError);
    }
  }, [apiError]);

  const filteredProducts = useMemo(() => {
    if (!products) return [];
    // Filter out products with zero quantity and apply search filter
    return products
      .filter(product => (product.quantity_available > 0)) // Exclude products with 0 quantity
      .filter(product =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
  }, [products, searchTerm]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setError(null);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const validateForm = () => {
    if (!formData.product) {
      setError("يرجى اختيار الصنف المتضرر");
      return false;
    }
    if (!formData.amount || isNaN(formData.amount) || parseFloat(formData.amount) <= 0) {
      setError("يرجى إدخال مبلغ صحيح");
      return false;
    }
    return true;
  };

  const onSubmit = () => {
    if (validateForm()) {
      handleSubmit(formData, setError);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="modal-container flex-column-reverse" closeButton>
        <Modal.Title>
          {mode === "add" ? "إضافة صنف متضرر" : "تعديل بيانات الصنف المتضرر"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Message variant="danger">{error}</Message>}
        <Form>
          {/* Product Dropdown with Search */}
          <Form.Group className="mb-3" controlId="damageProduct">
            <Form.Label>الصنف المتضرر</Form.Label>
            <Form.Control
              type="text"
              placeholder="ابحث عن صنف..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="mb-2"
            />
            <Form.Select
              name="product"
              value={formData.product}
              onChange={handleChange}
              required
            >
              <option value="">اختر الصنف المتضرر...</option>
              {filteredProducts.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.name} - المتوفر: {product.quantity_available}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          
          {/* Amount Input */}
          <Form.Group className="mb-3" controlId="amount">
            <Form.Label>الكمية المتضررة</Form.Label>
            <Form.Control
              type="number"
              step="1"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              placeholder="(الكمية المتضررة)"
              required
              dir="ltr"
              style={{ textAlign: "right" }}
            />
          </Form.Group>
          
          {/* Notes Input */}
          <Form.Group className="mb-3" controlId="notes">
            <Form.Label>ملاحظات (اختياري)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="ملاحظات إضافية..."
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          إلغاء
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          {mode === "add" ? "إضافة" : "تعديل"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DamagesTransactionsModal;